import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import CustomField from "../shared/CustomTextField";
import { Formik } from "formik";
import { Button, ListSubheader, MenuItem } from "@mui/material";
import moment from "moment-timezone";
import { useState } from "react";
import { orderStatus } from "../../utils/API/api-utils";
import { updateOrder } from "../../utils/API/schoolMethods";

export default function OrderForm() {
  const store = useStore();
  const orderData = store.form.dataToUpdate;
  const initValues = orderData;

  const handleUpdate = (values) => {
    updateOrder(values.id, {
      status: Number(values.status),
      reply_to_user: values.reply_to_user,
      group_id: Number(values.group_id) ? Number(values.group_id) : null,
    }).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={{
        id: orderData.id,
        status: orderData.status,
        reply_to_user: orderData.reply_to_user,
        group_id: "",
      }}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        handleUpdate(values);
        // submitSchool(values);
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
      }) => (
        <>
          <p>Рассмотрение заявки</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name={"status"}
                  label="Статус"
                  select
                  value={Number(values.status)}
                  onChanhe={handleChange}>
                  {Object.keys(orderStatus).map((status) => (
                    <MenuItem
                      onClick={() => setFieldValue("status", Number(status))}
                      value={Number(status)}>
                      {orderStatus[status].text}
                    </MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  name={"group_id"}
                  label="Зачислить в группу"
                  select
                  onChanhe={handleChange}
                  value={values.group_id}
                  disabled={values.status !== 1}>
                  {orderData.groupData.map((group) => (
                    <MenuItem
                      onClick={() =>
                        setFieldValue("group_id", Number(group.id))
                      }
                      value={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  name={"reply_to_user"}
                  onChange={(e) => {
                    setFieldValue(e.target.name, e.target.value);
                  }}
                  label="Сообщениеи для пользователя"
                  value={values.reply_to_user}
                  multiline
                  rows={3}
                />
              </div>
            </div>

            <div
              className="form_actions"
              style={{
                justifyContent: "flex-end",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}>
              <Button variant="contained" onClick={handleSubmit}>
                Сохранить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
